// ─── INCIDENT CATEGORY CONFIG ─────────────────────────────────────────────
export const INCIDENT_CATEGORIES = {
  fire: {
    label: 'Fire',
    icon: '🔥',
    color: '#FF3B3B',
    bg: 'rgba(255,59,59,0.12)',
    border: 'rgba(255,59,59,0.35)',
    responderType: 'firefighter',
    subcategories: ['Building Fire', 'Forest Fire', 'Vehicle Fire', 'Gas Leak', 'Explosion'],
  },
  medical: {
    label: 'Medical',
    icon: '🚑',
    color: '#1E90FF',
    bg: 'rgba(30,144,255,0.12)',
    border: 'rgba(30,144,255,0.35)',
    responderType: 'paramedic',
    subcategories: ['Cardiac Arrest', 'Accident Injury', 'Unconscious Person', 'Childbirth', 'Severe Bleeding', 'Poisoning'],
  },
  flood: {
    label: 'Flood',
    icon: '🌊',
    color: '#00C896',
    bg: 'rgba(0,200,150,0.12)',
    border: 'rgba(0,200,150,0.35)',
    responderType: 'rescue',
    subcategories: ['Flash Flood', 'Building Collapse', 'Landslide', 'Trapped in Water', 'Storm Damage'],
  },
  police: {
    label: 'Police',
    icon: '🚔',
    color: '#7C3AED',
    bg: 'rgba(124,58,237,0.12)',
    border: 'rgba(124,58,237,0.35)',
    responderType: 'police',
    subcategories: ['Kidnapping', 'Road Accident', 'Riot / Hangama', 'Missing Person', 'Theft / Robbery', 'Domestic Violence', 'Suspicious Activity'],
  },
  other: {
    label: 'Other',
    icon: '⚠️',
    color: '#FFB300',
    bg: 'rgba(255,179,0,0.12)',
    border: 'rgba(255,179,0,0.35)',
    responderType: 'general',
    subcategories: ['Power Outage', 'Animal Attack', 'Hazardous Material', 'Infrastructure Damage'],
  },
};

export const SEVERITY_LEVELS = {
  critical: { label: 'CRITICAL', color: '#FF3B3B', bg: 'rgba(255,59,59,0.15)', priority: 4 },
  high:     { label: 'HIGH',     color: '#FF6B00', bg: 'rgba(255,107,0,0.15)', priority: 3 },
  medium:   { label: 'MEDIUM',   color: '#FFB300', bg: 'rgba(255,179,0,0.15)', priority: 2 },
  low:      { label: 'LOW',      color: '#00C896', bg: 'rgba(0,200,150,0.15)', priority: 1 },
};

// ─── RESPONDER POOL ─────────────────────────────────────────────────────────
export const MOCK_RESPONDERS = [
  // Firefighters
  { id: 'resp-f1', name: 'Arjun Sharma', type: 'firefighter', role: 'Lead Firefighter', badge: 'FF-201', zone: 'zone-1', status: 'available', location: { lat: 20.2965, lng: 85.8250 }, distance: '0.8 km', eta: '3 min', skills: ['Fire Suppression', 'Rescue', 'HAZMAT'], phone: '+91-94370-11201', avatar: 'AS' },
  { id: 'resp-f2', name: 'Deepak Rao',   type: 'firefighter', role: 'Firefighter',      badge: 'FF-202', zone: 'zone-1', status: 'available', location: { lat: 20.2910, lng: 85.8220 }, distance: '1.4 km', eta: '5 min', skills: ['Fire Suppression', 'First Aid'],          phone: '+91-94370-11202', avatar: 'DR' },
  { id: 'resp-f3', name: 'Sujit Nayak',  type: 'firefighter', role: 'Firefighter',      badge: 'FF-203', zone: 'zone-2', status: 'on-scene', location: { lat: 20.2850, lng: 85.8300 }, distance: '2.1 km', eta: '8 min', skills: ['Aerial Rescue', 'Fire Suppression'],       phone: '+91-94370-11203', avatar: 'SN' },

  // Paramedics
  { id: 'resp-m1', name: 'Priya Patel',   type: 'paramedic', role: 'Senior Paramedic', badge: 'PM-301', zone: 'zone-1', status: 'available', location: { lat: 20.2900, lng: 85.8180 }, distance: '0.6 km', eta: '2 min', skills: ['Advanced Life Support', 'Trauma', 'Cardiac'], phone: '+91-94370-11301', avatar: 'PP' },
  { id: 'resp-m2', name: 'Rohit Mishra',  type: 'paramedic', role: 'Paramedic',        badge: 'PM-302', zone: 'zone-1', status: 'available', location: { lat: 20.2950, lng: 85.8100 }, distance: '1.1 km', eta: '4 min', skills: ['Basic Life Support', 'First Aid'],         phone: '+91-94370-11302', avatar: 'RM' },
  { id: 'resp-m3', name: 'Anita Das',     type: 'paramedic', role: 'Paramedic',        badge: 'PM-303', zone: 'zone-2', status: 'en-route',  location: { lat: 20.3020, lng: 85.8150 }, distance: '2.5 km', eta: '9 min', skills: ['Obstetrics', 'Pediatrics'],                 phone: '+91-94370-11303', avatar: 'AD' },

  // Police
  { id: 'resp-p1', name: 'Insp. Ravi Kumar',   type: 'police', role: 'Inspector',    badge: 'OD-1142', zone: 'zone-1', status: 'available', location: { lat: 20.2980, lng: 85.8260 }, distance: '0.4 km', eta: '2 min', skills: ['Investigation', 'Crowd Control', 'Negotiation'], phone: '+91-94370-11401', avatar: 'RK' },
  { id: 'resp-p2', name: 'SI Sneha Das',        type: 'police', role: 'Sub Inspector', badge: 'OD-1143', zone: 'zone-1', status: 'available', location: { lat: 20.2940, lng: 85.8200 }, distance: '0.9 km', eta: '3 min', skills: ['Patrol', 'Crowd Control'],                     phone: '+91-94370-11402', avatar: 'SD' },
  { id: 'resp-p3', name: 'Const. Mohan Behera', type: 'police', role: 'Constable',     badge: 'OD-1144', zone: 'zone-1', status: 'on-scene', location: { lat: 20.2870, lng: 85.8290 }, distance: '1.7 km', eta: '6 min', skills: ['Patrol', 'Traffic'],                            phone: '+91-94370-11403', avatar: 'MB' },

  // Rescue
  { id: 'resp-r1', name: 'Kiran Swain',  type: 'rescue', role: 'Rescue Specialist', badge: 'RS-401', zone: 'zone-1', status: 'available', location: { lat: 20.2920, lng: 85.8240 }, distance: '1.0 km', eta: '4 min', skills: ['Water Rescue', 'Swift Water', 'Rope Rescue'], phone: '+91-94370-11501', avatar: 'KS' },
  { id: 'resp-r2', name: 'Tapan Sahoo',  type: 'rescue', role: 'Rescue Diver',      badge: 'RS-402', zone: 'zone-2', status: 'available', location: { lat: 20.2800, lng: 85.8320 }, distance: '2.3 km', eta: '8 min', skills: ['Scuba Diving', 'Underwater Rescue'],          phone: '+91-94370-11502', avatar: 'TS' },
];

// ─── RESPONDER TYPE → INCIDENT TYPE MAPPING ─────────────────────────────────
export const RESPONDER_FOR_INCIDENT = {
  fire:    'firefighter',
  medical: 'paramedic',
  flood:   'rescue',
  police:  'police',
  other:   'general',
};

// ─── MOCK INCIDENTS WITH DISPATCH CHAIN ─────────────────────────────────────
export const MOCK_INCIDENTS = [
  {
    id: 'INC-A1B2C3',
    type: 'fire',
    subcategory: 'Building Fire',
    severity: 'critical',
    location: { lat: 20.2961, lng: 85.8245, address: 'MG Road, Bhubaneswar, Odisha' },
    description: 'Multistorey apartment building on fire, multiple families trapped on upper floors',
    reportedBy: 'user-123',
    status: 'active',
    priorityScore: 9.5,
    verificationScore: 91,
    peopleAffected: 47,
    dispatchChain: [
      { responderId: 'resp-f1', status: 'accepted', notifiedAt: Date.now() - 180000, respondedAt: Date.now() - 170000 },
      { responderId: 'resp-f2', status: 'standby',  notifiedAt: Date.now() - 180000, respondedAt: null },
    ],
    timeline: [
      { event: 'reported',   time: Date.now() - 272000, note: 'Citizen reported via SOS' },
      { event: 'ai_analyzed', time: Date.now() - 271000, note: 'AI: Threat Level 9 — Critical. Deploy 2+ units.' },
      { event: 'dispatched',  time: Date.now() - 270000, note: 'Arjun Sharma (FF-201) notified — PRIMARY' },
      { event: 'accepted',    time: Date.now() - 260000, note: 'Arjun Sharma accepted mission' },
      { event: 'en_route',    time: Date.now() - 255000, note: 'Unit en route — ETA 3 min' },
    ],
    createdAt: new Date(Date.now() - 272000),
    aiAnalysis: { threatLevel: 9, immediateActions: ['Evacuate all floors', 'Deploy aerial ladder', 'Notify gas company'], estimatedDuration: '60-90 min', evacuationRadius: 200, riskAssessment: 'High-rise fire with confirmed trapped occupants. Immediate multi-unit response required.' },
  },
  {
    id: 'INC-D4E5F6',
    type: 'police',
    subcategory: 'Road Accident',
    severity: 'high',
    location: { lat: 20.3012, lng: 85.8197, address: 'NH-16 near Patia Chowk, Bhubaneswar' },
    description: 'Multi-vehicle collision involving bus and two cars. 3 persons trapped. Traffic blocked.',
    reportedBy: 'user-456',
    status: 'pending',
    priorityScore: 7.5,
    verificationScore: 78,
    peopleAffected: 12,
    dispatchChain: [
      { responderId: 'resp-p1', status: 'notified', notifiedAt: Date.now() - 30000, respondedAt: null, timeoutAt: Date.now() + 30000 },
      { responderId: 'resp-p2', status: 'standby',  notifiedAt: Date.now() - 30000, respondedAt: null },
    ],
    timeline: [
      { event: 'reported',    time: Date.now() - 72000, note: 'Citizen SOS — road accident NH-16' },
      { event: 'ai_analyzed', time: Date.now() - 70000, note: 'AI: HIGH severity — Police + Medical required' },
      { event: 'dispatched',  time: Date.now() - 30000, note: 'Insp. Ravi Kumar (OD-1142) notified — awaiting response' },
    ],
    createdAt: new Date(Date.now() - 72000),
    aiAnalysis: { threatLevel: 7, immediateActions: ['Secure accident zone', 'Redirect traffic', 'Coordinate with medical'], estimatedDuration: '45 min', evacuationRadius: 100, riskAssessment: 'Multi-vehicle accident. Police + Paramedic dual response required.' },
  },
  {
    id: 'INC-G7H8I9',
    type: 'police',
    subcategory: 'Kidnapping',
    severity: 'critical',
    location: { lat: 20.2845, lng: 85.8312, address: 'Nayapalli, Bhubaneswar' },
    description: 'Child reported missing from school. Witness saw person forcing child into white car.',
    reportedBy: 'user-789',
    status: 'active',
    priorityScore: 10,
    verificationScore: 85,
    peopleAffected: 1,
    dispatchChain: [
      { responderId: 'resp-p1', status: 'accepted', notifiedAt: Date.now() - 600000, respondedAt: Date.now() - 590000 },
      { responderId: 'resp-p2', status: 'accepted', notifiedAt: Date.now() - 600000, respondedAt: Date.now() - 588000 },
    ],
    timeline: [
      { event: 'reported',    time: Date.now() - 900000, note: 'Parent reported — child missing' },
      { event: 'ai_analyzed', time: Date.now() - 898000, note: 'AI: CRITICAL — Kidnapping protocol activated' },
      { event: 'dispatched',  time: Date.now() - 600000, note: 'All available police units notified' },
      { event: 'accepted',    time: Date.now() - 590000, note: 'Insp. Kumar accepted — AMBER ALERT issued' },
    ],
    createdAt: new Date(Date.now() - 900000),
    aiAnalysis: { threatLevel: 10, immediateActions: ['Issue AMBER Alert', 'Block exit routes', 'Check CCTV footage', 'Coordinate with traffic police'], estimatedDuration: 'Ongoing', evacuationRadius: 0, riskAssessment: 'Child abduction — maximum priority. All units required.' },
  },
  {
    id: 'INC-J0K1L2',
    type: 'flood',
    subcategory: 'Flash Flood',
    severity: 'high',
    location: { lat: 20.2719, lng: 85.8414, address: 'Chandrasekharpur, Bhubaneswar' },
    description: 'Flash flood. Residential area waterlogged. Families on rooftops.',
    reportedBy: 'user-321',
    status: 'active',
    priorityScore: 8,
    verificationScore: 82,
    peopleAffected: 120,
    dispatchChain: [
      { responderId: 'resp-r1', status: 'accepted', notifiedAt: Date.now() - 400000, respondedAt: Date.now() - 390000 },
      { responderId: 'resp-r2', status: 'standby',  notifiedAt: Date.now() - 400000, respondedAt: null },
    ],
    timeline: [
      { event: 'reported',   time: Date.now() - 765000, note: 'Flash flood reported — Chandrasekharpur' },
      { event: 'ai_analyzed', time: Date.now() - 763000, note: 'AI: HIGH — Rescue boats required' },
      { event: 'dispatched',  time: Date.now() - 400000, note: 'Kiran Swain dispatched with rescue boat' },
    ],
    createdAt: new Date(Date.now() - 765000),
    aiAnalysis: { threatLevel: 8, immediateActions: ['Deploy rescue boats', 'Evacuate ground floors', 'Contact ODRF'], estimatedDuration: '3-4 hours', evacuationRadius: 500, riskAssessment: 'Widespread flooding — sustained rescue operation needed.' },
  },
  {
    id: 'INC-M3N4O5',
    type: 'police',
    subcategory: 'Riot / Hangama',
    severity: 'high',
    location: { lat: 20.2680, lng: 85.8180, address: 'Old Town Market, Bhubaneswar' },
    description: 'Large crowd clash near Old Town. Property damage. People injured. Stones being pelted.',
    reportedBy: 'user-555',
    status: 'pending',
    priorityScore: 8.5,
    verificationScore: 70,
    peopleAffected: 200,
    dispatchChain: [
      { responderId: 'resp-p2', status: 'notified', notifiedAt: Date.now() - 60000, respondedAt: null, timeoutAt: Date.now() + 15000 },
      { responderId: 'resp-p3', status: 'standby',  notifiedAt: Date.now() - 60000, respondedAt: null },
    ],
    timeline: [
      { event: 'reported',    time: Date.now() - 120000, note: 'Multiple citizens reported riot at market' },
      { event: 'ai_analyzed', time: Date.now() - 118000, note: 'AI: HIGH — Riot control + medical standby' },
      { event: 'dispatched',  time: Date.now() - 60000,  note: 'SI Sneha Das notified — awaiting response' },
    ],
    createdAt: new Date(Date.now() - 120000),
    aiAnalysis: { threatLevel: 8, immediateActions: ['Deploy riot control unit', 'Set up perimeter', 'Medical standby', 'Contact district magistrate'], estimatedDuration: '2-3 hours', evacuationRadius: 300, riskAssessment: 'Active riot situation — multiple units + medical backup needed.' },
  },
  {
    id: 'INC-P6Q7R8',
    type: 'medical',
    subcategory: 'Cardiac Arrest',
    severity: 'critical',
    location: { lat: 20.3050, lng: 85.8100, address: 'KIIT University Campus, Bhubaneswar' },
    description: 'Student collapsed in library. No pulse. CPR being administered by bystanders.',
    reportedBy: 'user-666',
    status: 'active',
    priorityScore: 10,
    verificationScore: 95,
    peopleAffected: 1,
    dispatchChain: [
      { responderId: 'resp-m1', status: 'accepted', notifiedAt: Date.now() - 120000, respondedAt: Date.now() - 115000 },
      { responderId: 'resp-m2', status: 'declined', notifiedAt: Date.now() - 120000, respondedAt: Date.now() - 110000, reason: 'Currently on another critical case' },
    ],
    timeline: [
      { event: 'reported',    time: Date.now() - 180000, note: 'Campus security called — cardiac arrest' },
      { event: 'ai_analyzed', time: Date.now() - 179000, note: 'AI: CRITICAL — ALS unit required immediately' },
      { event: 'dispatched',  time: Date.now() - 120000, note: 'Priya Patel (PM-301) notified — PRIMARY' },
      { event: 'accepted',    time: Date.now() - 115000, note: 'Priya Patel accepted — ETA 2 min' },
      { event: 'declined',    time: Date.now() - 110000, note: 'Rohit Mishra declined — on another case' },
      { event: 'en_route',    time: Date.now() - 110000, note: 'Priya Patel en route with AED' },
    ],
    createdAt: new Date(Date.now() - 180000),
    aiAnalysis: { threatLevel: 10, immediateActions: ['Continue CPR until paramedic arrives', 'Get AED from campus security', 'Clear the area'], estimatedDuration: '30-60 min', evacuationRadius: 0, riskAssessment: 'Cardiac emergency — every second counts. ALS paramedic dispatched.' },
  },
];

export const MOCK_SAFE_ZONES = [
  { id: 'sz-1', name: 'KIIT University Ground', distance: '0.8 km', capacity: 2000, occupancy: 340, lat: 20.3520, lng: 85.8150 },
  { id: 'sz-2', name: 'Kalinga Stadium', distance: '2.1 km', capacity: 5000, occupancy: 890, lat: 20.2750, lng: 85.8350 },
  { id: 'sz-3', name: 'Unit-1 Community Hall', distance: '3.4 km', capacity: 800, occupancy: 120, lat: 20.2950, lng: 85.8450 },
];

export const MOCK_ANALYTICS = {
  totalToday: 41,
  avgResponseTime: '2.1 min',
  falseAlarmRate: '3.8%',
  livesProtected: 18947,
  resolvedCount: 35,
  activeCount: 6,
  pendingCount: 4,
  incidentsByType: { fire: 10, medical: 16, flood: 4, police: 8, other: 3 },
  incidentsByHour: [
    { hour: '00', count: 1 }, { hour: '02', count: 0 }, { hour: '04', count: 1 },
    { hour: '06', count: 2 }, { hour: '08', count: 7 }, { hour: '10', count: 9 },
    { hour: '12', count: 6 }, { hour: '14', count: 5 }, { hour: '16', count: 8 },
    { hour: '18', count: 10 }, { hour: '20', count: 5 }, { hour: '22', count: 3 },
  ],
  sparklines: {
    incidents:     [33, 36, 38, 35, 41, 39, 41],
    responseTime:  [2.9, 2.6, 2.4, 2.3, 2.2, 2.1, 2.1],
    falseAlarm:    [5.0, 4.5, 4.2, 4.0, 3.9, 3.8, 3.8],
    lives:         [18700, 18750, 18800, 18850, 18900, 18930, 18947],
  },
};

export const DISPATCH_STATUS_CONFIG = {
  notified: { label: 'Awaiting Response', color: '#FFB300', bg: 'rgba(255,179,0,0.15)', icon: '🔔' },
  standby:  { label: 'On Standby',        color: '#1E90FF', bg: 'rgba(30,144,255,0.15)', icon: '⏳' },
  accepted: { label: 'Accepted',          color: '#00C896', bg: 'rgba(0,200,150,0.15)', icon: '✅' },
  declined: { label: 'Declined',          color: '#FF3B3B', bg: 'rgba(255,59,59,0.15)', icon: '❌' },
  en_route: { label: 'En Route',          color: '#00C896', bg: 'rgba(0,200,150,0.15)', icon: '🚀' },
  on_scene: { label: 'On Scene',          color: '#00C896', bg: 'rgba(0,200,150,0.15)', icon: '📍' },
};
